var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUbbeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 33,
    viewBox: "0 0 70 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "657797430a8abb97efcb4d90_bbe-logo-full-color-rgb 1",
    clipPath: "url(#clip0_606_195698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_606_195698",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 63,
    height: 33
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M62.5002 0.0012207H0.5V32.0003H62.5002V0.0012207Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_606_195698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.417 21.8106C15.417 18.7542 13.3589 16.4807 10.5103 16.4807C7.7817 16.4807 5.8019 18.7542 5.8019 21.8106C5.8019 24.9446 7.82085 27.1406 10.5103 27.1406C13.3589 27.1406 15.417 24.9058 15.417 21.8106ZM5.52536 29.2565V30.8078C5.52536 31.2489 5.16317 31.6076 4.71778 31.6076H1.30881C0.860965 31.6076 0.501225 31.2489 0.501225 30.8078V6.62066C0.501225 6.17952 0.860965 5.8208 1.30881 5.8208H4.99432C5.43971 5.8208 5.8019 6.17952 5.8019 6.62066V14.2072C7.22618 12.5226 9.48251 11.621 11.778 11.621C17.2377 11.621 20.7984 16.168 20.7984 21.8106C20.7984 27.4532 17.3161 32.0003 11.8563 32.0003C9.48251 32.0003 6.9888 31.1374 5.52536 29.2565Z",
    fill: "#251163"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M36.5372 21.8106C36.5372 18.7542 34.4816 16.4807 31.6306 16.4807C28.9019 16.4807 26.9221 18.7542 26.9221 21.8106C26.9221 24.9446 28.9411 27.1406 31.6306 27.1406C34.4816 27.1406 36.5372 24.9058 36.5372 21.8106ZM26.6456 29.2565V30.8078C26.6456 31.2489 26.2834 31.6076 25.838 31.6076H22.429C21.9812 31.6076 21.6214 31.2489 21.6214 30.8078V6.62066C21.6214 6.17952 21.9812 5.8208 22.429 5.8208H26.1145C26.5624 5.8208 26.9221 6.17952 26.9221 6.62066V14.2072C28.3464 12.5226 30.6027 11.621 32.8982 11.621C38.358 11.621 41.9187 16.168 41.9187 21.8106C41.9187 27.4532 38.4363 32.0003 32.9765 32.0003C30.6027 32.0003 28.109 31.1374 26.6456 29.2565Z",
    fill: "#251163"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M57.5135 20.1261C57.1195 17.6562 55.1397 16.0105 52.7268 16.0105C50.4313 16.0105 48.4539 17.6562 47.94 20.1261H57.5135ZM42.6369 21.8106C42.6369 16.168 47.0688 11.621 52.8859 11.621C58.2648 11.621 62.501 16.168 62.501 21.7331C62.501 22.1403 62.479 22.5475 62.452 22.8771C62.4202 23.294 62.0703 23.6139 61.6469 23.6139H48.0183C48.6497 26.3165 50.9061 27.6108 53.5172 27.6108C55.1251 27.6108 56.7867 27.2181 58.1474 26.5055C58.5487 26.2947 59.0455 26.4352 59.2535 26.8328L60.4894 29.1838C60.6925 29.5668 60.5456 30.037 60.1663 30.2552C58.1107 31.4283 55.7956 32.0003 53.4781 32.0003C47.7027 32.0003 42.6369 28.2773 42.6369 21.8106Z",
    fill: "#251163"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M58.5105 5.14214C55.9092 3.13766 52.3925 2.745 49.4069 4.12414L49.1157 4.25745L54.0884 7.18298L58.5105 5.14214Z",
    fill: "#00B2B1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M44.8541 7.25812L43.8703 6.67883L36.9276 9.88552C39.529 11.89 43.0456 12.2851 46.0337 10.9035L52.6974 7.82771C50.167 8.86025 47.2548 8.6712 44.8541 7.25812Z",
    fill: "#00B2B1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M43.9513 1.22024C41.1174 -0.447338 37.5788 -0.403709 34.7889 1.33658L43.8706 6.67864L49.1149 4.25726L43.9513 1.22024Z",
    fill: "#AFD100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M49.1149 4.25769L43.8706 6.67907L44.8543 7.25836C47.2551 8.67143 50.1672 8.86049 52.6977 7.82795L54.0901 7.18322L49.1149 4.25769Z",
    fill: "#251163"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_606_195698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbbeLogo);
export default __webpack_public_path__ + "static/media/ubbe_logo.eca4866f390c38cc4860563ef315fe16.svg";
export { ForwardRef as ReactComponent };